import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AdDirective } from './directives/ad.directive';
import { ClipboardDirective } from './directives/clipboard.directive';
import { DragDropFileDirective } from './directives/drag-drop-file.directive';
import { HeaderDirective } from './directives/header.directive';
import { MenuAsideOffcanvasDirective } from './directives/menu-aside-offcanvas.directive';
import { MenuAsideToggleDirective } from './directives/menu-aside-toggle.directive';
import { MenuAsideDirective } from './directives/menu-aside.directive';
import { MenuHorizontalOffcanvasDirective } from './directives/menu-horizontal-offcanvas.directive';
import { MenuHorizontalDirective } from './directives/menu-horizontal.directive';
import { PortletDirective } from './directives/portlet.directive';
import { QuickSearchDirective } from './directives/quick-search.directive';
import { QuickSidebarOffcanvasDirective } from './directives/quick-sidebar-offcanvas.directive';
import { ScrollTopDirective } from './directives/scroll-top.directive';
import { ConsoleLogPipe } from './pipes/console-log.pipe';
import {AjustarFusoDinamicoPipe, DataPipe, DateTimeIgnorarFusoLocalPipe, DateTimePipe} from './pipes/date.pipe';
import { FirstLetterPipe } from './pipes/first-letter.pipe';
import { GetObjectPipe } from './pipes/get-object.pipe';
import { JoinPipe } from './pipes/join.pipe';
import { MinuteToTimePipe } from './pipes/minute-to-time.pipe';
import { MoedaMilharPipe } from './pipes/moeda-milhar.pipe';
import { MoedaPipe } from './pipes/moeda.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { TimeElapsedPipe } from './pipes/time-elapsed.pipe';
import { TimePipe } from './pipes/time.pipe';
import {HoraMinutoPipe} from './pipes/hora-minuto.pipe';
import {FloatToIntPipe} from "./pipes/float-to-int.pipe";
import {CapacidadeFormaterPipe} from "./pipes/capacidade.pipe";
import {TruncatePipe} from "./pipes/truncate.pipe";
import {KmInputDirective} from "./directives/km-input.directive";
import { TimeZonePipe } from './pipes/time-zone.pipe';
import { DataHoraFusoLocalPipe } from './pipes/data-hora-fuso-local.pipe';

@NgModule({
	imports: [CommonModule],
	declarations: [
		// directives
		MenuAsideDirective,
		MenuAsideOffcanvasDirective,
		MenuHorizontalOffcanvasDirective,
		MenuHorizontalDirective,
		ScrollTopDirective,
		HeaderDirective,
		MenuAsideToggleDirective,
		QuickSidebarOffcanvasDirective,
		QuickSearchDirective,
		ClipboardDirective,
		PortletDirective,
		DragDropFileDirective,
		AdDirective,
		KmInputDirective,
		// pipes
		FirstLetterPipe,
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		ConsoleLogPipe,
		SafePipe,
		MoedaPipe,
		DataPipe,
		MoedaMilharPipe,
		DateTimePipe,
		TimePipe,
		MinuteToTimePipe,
		HoraMinutoPipe,
		FloatToIntPipe,
		DateTimeIgnorarFusoLocalPipe,
		CapacidadeFormaterPipe,
		TruncatePipe,
		TimeZonePipe,
		DataHoraFusoLocalPipe,
		AjustarFusoDinamicoPipe
	],
	exports: [
		// directives
		MenuAsideDirective,
		MenuAsideOffcanvasDirective,
		MenuHorizontalOffcanvasDirective,
		MenuHorizontalDirective,
		ScrollTopDirective,
		HeaderDirective,
		MenuAsideToggleDirective,
		QuickSidebarOffcanvasDirective,
		QuickSearchDirective,
		ClipboardDirective,
		PortletDirective,
		DragDropFileDirective,
		AdDirective,
		KmInputDirective,
		// pipes
		FirstLetterPipe,
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		ConsoleLogPipe,
		SafePipe,
		MoedaPipe,
		DataPipe,
		DateTimePipe,
		TimePipe,
		MinuteToTimePipe,
		MoedaMilharPipe,
		HoraMinutoPipe,
		FloatToIntPipe,
		DateTimeIgnorarFusoLocalPipe,
		CapacidadeFormaterPipe,
		TruncatePipe,
		TimeZonePipe,
		DataHoraFusoLocalPipe,
		AjustarFusoDinamicoPipe
	],
	providers: []
})
export class CoreModule { }
